(function () {

    /* globals angular, moment, $ */

    angular
        .module('ngmvac')
        .controller('IndexPageController', IndexController);

    IndexController.$inject = ['$window', 'HotelFactory', 'DatosCotizador', '$location', '$http'];

    function IndexController($window, HotelFactory, DatosCotizador, $location, $http) {
        $('#home').show();
        $('.splash').hide();
        $('body').removeClass('no-scroll');

        var vm = this;

        // Variable del scope
        vm.step = 1;
        vm.initialStay = {
            checkIn: moment().add(14, 'days').format('YYYY-MM-DD'),
            checkOut: moment().add(15, 'days').format('YYYY-MM-DD')
        };
        vm.initialStay2021 = {
            checkIn: moment("20210101").add(4, 'days').format('YYYY-MM-DD'),
            checkOut: moment("20210101").add(5, 'days').format('YYYY-MM-DD')
        };
        vm.setInitialStay2021 = false;
        vm.initializationData = {};
        vm.cotizadorSeleccionado = 1;

        if(document.querySelector('#frequentCustomerId').value == '1'){
            vm.cotizadorSeleccionado = 2;
        }

        if(moment("20210101").diff(moment(), 'days') > 0 && $('#calendar2021').val() === 'true'){
            vm.setInitialStay2021 = true;
            $('#available-2021').removeClass('d-none');
        }
        console.log($('#calendar2021').val(), vm.setInitialStay2021)

        vm.pathImagesNormal = 'https://photos.hotelbeds.com/giata';
        vm.pathImages = 'https://photos.hotelbeds.com/giata/bigger';
        vm.pathImagesMini = 'https://photos.hotelbeds.com/giata/small';

        if($('#idUsuario').val() > 0){
            localStorage.setItem('uidFenix', $('#idUsuario').val());
        }else{
            localStorage.removeItem('uidFenix');
        }
        vm.searches = localStorage.getItem('searches') == null || localStorage.getItem('searches').length == 0 ? [] : JSON.parse(localStorage.getItem('searches'));

        if(vm.searches.length > 0){
            vm.searches2 = [];
            angular.forEach(vm.searches, function (value, index) {
                vm.datesF = value.search.stay;
                vm.datesF.checkIn
                vm.datesF.checkOn

                vm._date = moment(vm.datesF.checkIn)
                vm._now = moment();

                if (vm._now < vm._date) {
                    // date is past
                    vm.searches2.push(value);

                }
                localStorage.setItem('searches',JSON.stringify(vm.searches2))

            });
        }

        // if(window.location.pathname === '/', "route") {
        //     localStorage.removeItem('search');
        // }
        
        vm.backToTop = function() {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        }
        var amountScrolled = 300;
        $(window).scroll(function() {
            if ($(window).scrollTop() > amountScrolled) {
                $('a.back-to-top').fadeIn('slow');
            } else {
                $('a.back-to-top').fadeOut('slow');
            }
        });

        // Funciones del scope
        vm.press = fnPress;

        // Definicion de las funciones del scope
        function alertMsg(msg) {
            $('#alertContainer').html('<div class="alert alert-warning alert-dismissible" role="alert">' + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + '</button>' + msg + '</div>');
        }


        vm.selectedTab = function(tab) {
            vm.cotizadorSeleccionado = tab;
        }


        vm.loadDetails = function(item) {
  
            localStorage.setItem('search', JSON.stringify(item.search));
            localStorage.setItem('hotelSelected', JSON.stringify(item.hotel));
            window.open('/hotel/details/mexicovacations?flt=' + 'ALL', '_self');
        }
        window.loadEvent=function(){
            $('#showLoadCartrawler').hide();
            $('#showIframeCartrawler').show();
            vm.showIframeCartrawler = true;
            $('#showIframeCartrawler').removeClass('ng-hide');            
          }        

        //HotelFactory.deleteLocalStorage();

        function fnPress($event) {
            if ($event.isValid) {
                vm.loaderStyle = {
                    display: 'flex'
                };

                HotelFactory.obtenerHoteles();

                if (DatosCotizador.type === 'Hotel') {
                    // $window.location.href = '/hotel/details/' + DatosCotizador.destination.token;
                    $window.location.href = '/hotel/details/mexicovacations?flt=ALL';
                } else {
                    // $window.location.href = '/hotel';
                    $window.location.href = '/hotelv2';
// 
                }
            }
        }
    }

})();